/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'actions-controls-play': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<path pid="0" fill-rule="evenodd" d="M4.375 17.5a.625.625 0 01-.625-.625V3.125a.625.625 0 01.938-.544l11.875 6.875a.625.625 0 010 1.088L4.688 17.419a.625.625 0 01-.313.081zM5 4.206v11.588L15 10 5 4.206z"/>'
  }
})
